import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show popup after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    if (isChecked) {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.setItem('cookieConsentDate', new Date().toISOString());
      setIsVisible(false);
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-popup">
        <div className="cookie-consent-header">
          <h3>הסכמה לשימוש בעוגיות</h3>
        </div>

        <div className="cookie-consent-content">
          <p>
            אתר זה משתמש בעוגיות (Cookies) כדי לשפר את חווית הגלישה שלך,
            לנתח את תעבורת האתר ולהציג תוכן מותאם אישית.
          </p>
          <p>
            למידע נוסף, אנא קרא את <Link to="/privacy">מדיניות הפרטיות</Link> שלנו.
          </p>
        </div>

        <label className="cookie-consent-checkbox">
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <span className="checkmark">
            {isChecked && <FiCheck size={14} />}
          </span>
          <span className="checkbox-label">
            קראתי ואני מסכים/ה לשימוש בעוגיות ול<Link to="/privacy">מדיניות הפרטיות</Link>
          </span>
        </label>

        <div className="cookie-consent-buttons">
          <button
            className="cookie-btn accept"
            onClick={handleAccept}
            disabled={!isChecked}
          >
            אישור
          </button>
          <button
            className="cookie-btn decline"
            onClick={handleDecline}
          >
            דחייה
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
